const axios = require("axios");
const queryString = require("querystring");

const currencyAliases = {
    "Euro": "EUR",
    "Pound": "GBP",
};

module.exports = {
    authenticatedMiddleware(req, res, next) {
        const {
            id
        } = req.session.customer;

        if (!id) {
            res.status(401).json({
                error: {
                    status: 401,
                    message: "You must be logged in to use this route"
                }
            });
        } else {
            next();
        }
    },

    /**
     * @description 301 Redirect for routes that control pagination from /some-route?currentPage=1 to /some-route/page/1, while retaining previous query paramerters
     * @param {String} prefix
     * @param {String} param
     */
    paginationRedirectMiddleware() {
        return (req, res, next) => {
            const {
                currentPage,
                ...withoutCurrentPage
            } = req.query;
            const queryWithoutCurrentPage = queryString.encode(withoutCurrentPage) !== "" ? `?${queryString.encode(withoutCurrentPage)}` : "";
            const path = req.path == "/" ? req.path : `${req.path}/`;

            if (currentPage) {
                res.redirect(301, `${req.baseUrl}${path}page/${currentPage}${queryWithoutCurrentPage}`);
            } else if (req.params !== {} && req.params.pageNo && isNaN(parseInt(req.params.pageNo))) {
                res.redirect(301, `${req.baseUrl}${path}page/1${queryWithoutCurrentPage}`);
            } else {
                next();
            }
        };
    },

    buildMap: function (obj) {
        if (obj instanceof Map) {
            return obj;
        } else {
            let map = new Map();

            Object.keys(obj).forEach(key => {
                map.set(key, obj[key]);
            });
            return map;
        }
    },

    /**
     * Build SearchCriteria request from cleaner Object format
     * @param {Object} options
     * @param {Object} options.fields
     * @param {Array} options.filterGroups
     * @param {String} options.filterGroups.field
     * @param {String|Number} options.filterGroups.value
     * @param {String=} options.filterGroups.condition
     * @return {Object}
     */
    buildSearchCriteria: function (options) {
        let filterGroups = {};
        let sortOrders = {};
        let fields = {};

        if (options.filterGroups) {
            let filterGroupsMap = (typeof options.filterGroups === "string") ? this.buildMap(JSON.parse(options.filterGroups)) : this.buildMap(options.filterGroups),
                filterGroupsIndex = 0,
                filtersIndex = 0;

            filterGroupsMap.forEach((filter) => {
                let currentFilter = {
                    [`searchCriteria[filter_groups][${filterGroupsIndex}][filters][${filtersIndex}][field]`]: filter.field,
                    [`searchCriteria[filter_groups][${filterGroupsIndex}][filters][${filtersIndex}][value]`]: filter.value,
                    [`searchCriteria[filter_groups][${filterGroupsIndex}][filters][${filtersIndex}][condition_type]`]: filter.condition || "eq"
                };

                if (!filter.logic) {
                    filter.logic = "and";
                }

                if (filter.logic.toLowerCase() === "and") {
                    filterGroupsIndex++;
                    filtersIndex = 0; // Reset OR index to 0 upon "and"
                } else {
                    filtersIndex++;
                }

                filterGroups = Object.assign(filterGroups, currentFilter);
            });
        }

        if (options.sortOrders) {
            let sortOrdersMap = (typeof options.sortOrders === "string") ? this.buildMap(JSON.parse(options.sortOrders)) : this.buildMap(options.sortOrders);

            sortOrdersMap.forEach((sortOrder, sortOrdersIndex) => {
                let currentSort = {
                    [`searchCriteria[sortOrders][${sortOrdersIndex}][field]`]: sortOrder.field,
                    [`searchCriteria[sortOrders][${sortOrdersIndex}][direction]`]: sortOrder.direction
                };

                sortOrders = Object.assign(sortOrders, currentSort);
            });
        }

        if (options.fields) {
            fields = {
                fields: options.fields
            };
        }

        let pagination = {
            "searchCriteria[pageSize]": options.pageSize || 16,
            "searchCriteria[currentPage]": options.currentPage || 1
        };
        let searchCriteria = Object.assign({}, filterGroups, pagination, sortOrders, fields);

        return searchCriteria;
    },

    /**
     *
     * @param {string} string
     */
    capitalize(string) {
        return string.charAt(0).toUpperCase + string.substring(1);
    },

    /**
     * Convert one dimensional Array to a key, value Map object
     * @param  {Array} array [description]
     * @return {Map}       [description]
     */
    convertSolrFacetArrayToMap(array) {

        let facetMap = new Map();

        for (let i = 0; i < array.length; i += 2) {
            facetMap.set(array[i], array[(i + 1)]);
        }

        return facetMap;
    },

    /**
     * Convert one dimensional Array to a key, value Obbject
     * @param  {Array} array [description]
     * @return {Object}       [description]
     */
    convertSolrFacetArrayToObject(array) {

        let facetObject = {};

        for (let i = 0; i < array.length; i += 2) {
            facetObject[array[i]] = array[(i + 1)];
        }

        return facetObject;
    },


    /**
     * convert string to be in a presentational format for like titles
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertToTitle(value) {
        let title = `${value.slice(0,1).toUpperCase()}${value.slice(1)}`;

        title = title.replace(/_/g, "");
        title = title.replace("and", "");
        title = title.replace("name", "");
        title = title.replace("ids", "");
        title = title.replace("id", "");
        title = title.replace("facet", "");

        return title;
    },

    /**
     * convert string to be in format for urlKeys
     * @param  {String} value [description]
     * @return {String}        [description]
     */
    convertToUrlKey(value) {
        const NON_ASCII_REGEX = /[^\w \-\xC0-\xFF]/g,
            SPACE_REGEX = /(\s+(-+)\s*)|(\s*(-+)\s+)|(\s+)|(\/+)/g,
            MAX_RANGE = [50, 60];

        let urlKey = value.toLowerCase();

        urlKey = urlKey.replace(NON_ASCII_REGEX, "-");
        urlKey = urlKey.replace(SPACE_REGEX, "-");

        while (urlKey.startsWith("-")) {
            urlKey = urlKey.replace("-", "");
        }

        urlKey = urlKey.split("-");

        let finalUrlKey = "";

        urlKey.forEach((word, index) => {
            if (finalUrlKey.length < MAX_RANGE[0] && (`${finalUrlKey}-${word}`).length < MAX_RANGE[1] && word != "") {
                index == 0 ? finalUrlKey += `${word}` : finalUrlKey += `-${word}`;
            }
        });

        return finalUrlKey;
    },

    createUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c == "x" ? r : (r & 0x3 | 0x8);

            return v.toString(16);
        }).toUpperCase();
    },

    /**
     * Returns a function that will not be invoked until wait time passes, unless immediate is passed
     *
     * @param {Function} func - Function to be called after wait time
     * @param {Number} wait - Amount of time to debounce in MS
     * @param {Boolean} immediate - If `immediate` is passed, trigger the function on the leading edge, instead of the trailing
     */
    debounce(func, wait, immediate) {
        var timeout;

        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    findMode: function (arr) {
        var numMapping = {};
        var greatestFreq = 0;
        var mode;

        arr.forEach((number) => {
            if (number > 0) {
                numMapping[number] = (numMapping[number] || 0) + 1;

                if (greatestFreq < numMapping[number]) {
                    greatestFreq = numMapping[number];
                    mode = number;
                }
            }
        });
        return +mode;
    },

    /**
     * Generate an A-Z Array
     * @return {String[]} ["A","B","C",...]
     */
    getAlphabet() {
        const alphabet = [];

        for (let i = 65; i < 91; i++) {
            alphabet.push(String.fromCharCode(i));
        }

        return alphabet;
    },

    /**
     * Returns custom attribute from a product - if not found will return blank object
     * @param {Object} product - Product object to search for custom attribute
     * @param {String} attribute_code - Attribute code to search for
     * @param {Any} defaultValue - Default value to return if no attribute exists (defaults to empty string)
     */
    getCustomAttribute(product, attribute_code, defaultValue = "") {
        return product.custom_attributes.find(attr => attr.attribute_code == attribute_code) || {
            "attribute_code": attribute_code,
            "value": defaultValue
        };
    },

    /**
     *  Gets nested properties in an object without getting errors.
     * @param {Object} obj
     * @param {String} path Period seperated path
     * @param {Any} defaultValue default value to return if undefined (default undefined)
     */
    getDeepValue(obj, path, defaultValue = undefined) {
        const splitPath = path.split(".");
        let value = {
            ...obj
        };

        splitPath.forEach((key, i) => {
            if (Number.isInteger(key)) key = Number(key);
            value = value[key] || (splitPath.length != i + 1) && {} || undefined;
        });

        return value || defaultValue;
    },

    getEquipmentCategories(idKey = "value", nameKey = "label") {
        return (axios.get("/api/categories/equipment")
            .then(({data: tier3CategoryList}) => tier3CategoryList
                .map(({id, name}) => ({
                    [idKey]: id,
                    [nameKey]: name,
                }))
            )
        );
    },

    /**
     * Given a current page, the old page size and new page size, will return what the new current page should be.
     * @param {Number} currentPage - Current Page of Pagination
     * @param {Number} oldPageSize  - Old Page Size
     * @param {Number} newPageSize  - New Page Size Selected
     */
    getNewCurrentPage(currentPage, oldPageSize, newPageSize) {
        const oldStartingProductNo = ((currentPage * oldPageSize) - oldPageSize + 1);
        const newCurrentPage = Math.ceil(oldStartingProductNo / newPageSize);

        return newCurrentPage;
    },

    /**
     * getRandomNumber
     * returns the defined key
     * @param   min - int - an Integer start of range
     * @param   max - int - an Integer end of range
     * @return  int - random value between min and max
     **/
    getRandomNumber(min, max) {
        if (min === undefined) {
            min = "not set - force fail";
        }
        if (!/^-?[0-9]{1,}$/.test(min)) {
            throw new Error("Expected a Minimun Value as an integer to be passed as the first Parameter");
        }
        if (max === undefined) {
            max = "not set - force fail";
        }
        if (!/^-?[0-9]{1,}$/.test(max)) {
            throw new Error("Expected a Maximum Value as an integer to be passed as the second Parameter");
        }
        return Math.floor(Math.random() * (max - min)) + min;
    },

    getSellerGroup(sellerid) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/seller-groups/member/${sellerid}`).then(({
                data: sellerGroupType
            }) => {
                resolve(sellerGroupType);
            }).catch(reject);
        });
    },

    /**
     * Convert item with custom_attributes array into the root object layer
     * @param  {Object} item
     * @param  {Object[]} item.custom_attributes
     * @param  {String} item.custom_attributes[].attribute_code
     * @param  {String|Number} item.custom_attributes[].value
     * @return {Object} Original Item object with custom attributes included in the root layer
     */
    processCustomAttributes(item) {
        if (item.custom_attributes) {
            let customAttributes = {};

            item.custom_attributes.forEach((item) => {
                let newProperty = {
                    [item.attribute_code]: item.value
                };

                customAttributes = Object.assign(customAttributes, newProperty);
            });

            delete item.custom_attributes;

            return Object.assign(item, customAttributes);
        } else {
            return item;
        }


    },

    /**
     * Convert List of items with custom_attributes array into the root object layer
     * @param  {Object[]} items
     * @param  {Object[]} items[].custom_attributes
     * @param  {String} items[].custom_attributes[].attribute_code
     * @param  {String|Number} items[].custom_attributes[].value
     * @return {Object} Original Item object with custom attributes included in the root layer
     */
    processCustomAttributesByList(items) {
        let processedItems = items.map((item) => {
            return this.processCustomAttributes(item);
        });

        return processedItems;
    },

    promiseSerial(funcs) {
        funcs.reduce((promise, func) =>
            promise.then(result => func().then(Array.prototype.concat.bind(result))),
        Promise.resolve([]));
    },

    /**
     * Sets nested properties in an object
     * @param {Object} obj
     * @param {String} path Nested path as a string
     * @param {Any} value
     * @return {Object} updated object
     * @see https://stackoverflow.com/a/13719796 - Slightly modified
     */
    setDeepValue(obj, path, value) {
        var ref = obj;

        path.split(".").forEach(function (key, index, arr) {
            if (!isNaN(key)) key = Number(key);
            ref = ref[key] = index === arr.length - 1 ? value : ref[key] || {};
        });

        return obj;
    },

    /**
     * Shorten a string to less than maxLen characters without truncating words.
     * @param  {String} str          [description]
     * @param  {Number} maxLen       [description]
     * @param  {String} [separator=" "]            [description]
     * @return {[type]}              [description]
     */
    shorten(str, maxLen, separator = " ") {
        if (str.length <= maxLen) {
            return str;
        }
        return {
            truncated: str.slice(0, str.lastIndexOf(separator, maxLen)),
            rest: str.slice(str.lastIndexOf(separator, maxLen))
        };
    },

    /**
     * Shuffles an arrays values
     * @param  {Array} array [description]
     * @return {Array}       [description]
     */
    shuffle(array) {
        var currentIndex = array.length,
            temporaryValue,
            randomIndex;

        // While there are still more to shuffle
        while (currentIndex !== 0) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    },

    /**
     * Sorts an array of objects by the key you pass (the values must be numeric)
     * @param  {Array} array          [description]
     * @param  {String} key       [description]
     */
    sortByNumberKeyValue(array, key) {
        return array.sort((a, b) => {
            return parseInt(a[key]) - parseInt(b[key]);
        });
    },


    sum: function (arr) {
        let sum = 0;

        for (let item of arr) {
            sum += item;
        }
        return sum;
    },

    /**
     * Simple check for numeric values.
     *
     * Things that are numbers: 7, 7.04, "7.04", "3.000400";
     * Things that are not: "$7", "704 cats", "Bob";
     *
     * @param {string|number} value The value to check.
     *
     * @returns {boolean} true if the value is a number.
     */
    isNumeric(value) {
        return parseFloat(value) == value;
    },

    /**
     * Formats a price using the given currency.
     *
     * Uses `toLocaleString` to do the formatting, falling back on `toFixed` if
     * the currency is invalid. The currency will also be normalized.
     *
     * @param {number} rawPrice The numeric price of the product.
     * @param {string|object} [currencyOption=USD] Either a valid currency code,
     *     or the currency option value from Magento.
     * @param {string} [locale=en-us] The locale to use when formatting the
     *     the price. This will determine separators, number of decimal places,
     *     and which country's "dollars" get the un-prefixed "$" instead of,
     *     for example, "CA$" or "HK$".
     *
     * @returns {object} An object containing the formated `price` and the
     *     normalized `currency` value.
     */
    formatPrice(rawPrice, currencyOption = "USD", locale = "en-us") {
        let currency = currencyOption;
        let price;

        if (typeof currency !== "string") {
            currency = currency.label;
        }

        if (currencyAliases[currency]) {
            currency = currencyAliases[currency];
        }

        if (this.isNumeric(rawPrice)) {
            rawPrice = typeof rawPrice === "number" ? rawPrice : parseFloat(rawPrice);
            try {
                price = rawPrice.toLocaleString(locale, {
                    style: "currency",
                    currency
                });
            } catch (e) {
                console.error(`${e.message}. Falling back to simple price.`);
                price = rawPrice.toFixed(2);
            }
        } else {
            price = rawPrice;
        }

        return {
            price,
            currency,
        };
    },

    /**
     * Modifies a product's price, special price, and currency in place.
     *
     * @param {object} product The product to format currency on.
     * @param {array|null} [currencies=null] Currency option objects from
     *     Magento. If not provided, the currency will be use as-is.
     * @param {string} [locale=en-us] The locale to pass to `formatPrice`.
     */
    applyCurrencyFormatting(product, currencies = null, locale = "en-us") {
        let price, special_price, currency;

        if (currencies) {
            currency = currencies.find(({
                value
            }) => value == product.currency);
        } else {
            currency = product.currency;
        }

        ({
            price,
            currency
        } = this.formatPrice(product.price, currency, locale));
        product.price = price;
        product.currency = currency;

        if (product.special_price) {
            ({
                price: special_price
            } = this.formatPrice(product.special_price, currency, locale));
            product.special_price = special_price;
        }
    },

    /**
     * Returns an updated custom_attributes array when given the current array, and a new/modified modified_attribute
     *
     * @param {Array} custom_attributes - Array of custom attributes
     * @param {Object} modified_attribute  - Updated/New custom attribute
     */
    updateCustomAttribute(custom_attributes, modified_attribute) {
        const updateAttribute = (new_attr) => {
            const index = custom_attributes.findIndex(attr => attr.attribute_code == new_attr.attribute_code);

            if (index >= 0) {
                custom_attributes[index] = new_attr;
            } else {
                custom_attributes.push(new_attr);
            }
        };

        if (Array.isArray(modified_attribute)) {
            modified_attribute.forEach(new_attr => updateAttribute(new_attr));
        } else {
            updateAttribute(modified_attribute);
        }

        return custom_attributes;
    },

    objectArrayUnique(array, property = "value") {
        return array.filter((item, index) => {
            return array.findIndex(i => i[property] == item[property]) >= index;
        });
    }
};
